import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import {
  type IResponseBroadcastById,
  type IResponseEventBroadcast,
} from 'entities/Broadcast/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IHandlerEvent = (data: IResponseBroadcastById) => void

export const useEventBroadcastCanceled = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()
  const callback = (data: IResponseEventBroadcast) => {
    handler(data.broadcast)
  }

  useEffect(() => websocket.on(WebsocketEvent.BroadcastCanceled, callback), [])
}
